import React from "react";

// primereact components
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";

// context
import { useSendStation } from "../../../../../../context/SendStationContext";

// styles
import * as styles from "./SendStationModalContent.module.css";

export const EmailField = ({ inputRef }) => {
  const { email, setEmail, emailEditable, setEmailEditable, isEmailValid } =
    useSendStation();

  return (
    <div className={styles.formSection}>
      <h4 className={styles.sectionTitle}>Send to</h4>

      {emailEditable ? (
        <InputText
          ref={inputRef}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter email"
          className={styles.emailInput}
          onBlur={() => {
            if (isEmailValid) setEmailEditable(false);
          }}
        />
      ) : (
        <div className={styles.emailReadonly}>
          <span>{email}</span>

          <Button
            icon="pi pi-pencil"
            className={styles.editEmailBtn}
            onClick={() => setEmailEditable(true)}
          />
        </div>
      )}
    </div>
  );
};
